import { createTypes } from 'reduxsauce'
import { IComponentState} from '../root.types'
import { Ngo } from '../../application/models/ngo/ngo'

export const NgoTypes = createTypes(`

    LOAD_NGO_SUCCESS
    LOAD_NGO_FAILURE 
    LOAD_NGO_REQUEST

    CREATE_NGO_REQUEST
    CREATE_NGO_SUCCESS
    CREATE_NGO_FAILURE

    FIND_NGO_SUCCESS
    FIND_NGO_FAILURE 
    FIND_NGO_REQUEST

    UPDATE_NGO_REQUEST
    UPDATE_NGO_SUCCESS
    UPDATE_NGO_FAILURE
`,
    {
        prefix: '@ngo/'
    }
)

/**
 * State type
 */
export interface INgoState {
    readonly create: ICreateState
}
export interface ICreateState extends IComponentState {
    readonly ngo: Ngo
}
export interface IActionCreate{
    readonly ngo: Ngo
}
export interface IActionFind{
    readonly ngoId: string
}
export interface IActionUpdate{
     readonly ngo: Ngo
}